export default __webpack_public_path__ + "media/images/icons/mixed-filled-712bf50e299bcc13d20b5ce0a129aa9d.svg";